import React from "react";
import Navbar from "../components/navbar/Navbar";
import HeroSection from "../components/herosection/HeroSection";

function Home() {
  return (
    <>
      <HeroSection />
    </>
  );
}

export default Home;
